var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPinIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.971,
    height: 16.971,
    viewBox: "0 0 16.971 16.971",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "pin",
    d: "M6.7,9.424V7.7l3.788-3.939L8.239,1.517,4.3,5.3l-1.7.009L4.67,7.39,4.662,7.4,6.7,9.424M0,12,1.5,9.384l.07-.024L3.539,7.39,1.77,5.619q-.5-.493.105-1.1l2.1-.012L7.125,1.478l-.152-.152A.76.76,0,0,1,6.738.768.734.734,0,0,1,6.967.223.76.76,0,0,1,7.518,0a.78.78,0,0,1,.557.223l3.7,3.695A.781.781,0,0,1,12,4.475a.781.781,0,0,1-.779.78.723.723,0,0,1-.545-.235l-.152-.141L7.5,8.023v2.1q-.621.61-1.113.117L4.605,8.469,2.637,10.428l-.012.07Z",
    transform: "translate(0 8.485) rotate(-45)",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPinIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pin_icon.9a22e50c57088496a3c217c7d07a28c5.svg";